__webpack_require__.p = "https://uat.byonde.asia/";